















import { defineComponent } from '@nuxtjs/composition-api';
import useUrlFormatter from '~/hooks/useUrlFormatter';

export default defineComponent({
  name: 'PLPCareplanUsps',
  props: {
    usps: {
      type: Array,
      required: true,
      default: () => []
    },
    mobileDisplayedUspIndex: {
      type: Number,
      default: 0
    }
  },
  setup() {
    const formatUrl = useUrlFormatter();

    return {
      formatUrl
    };
  }
});
